import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Building2, X } from 'lucide-react';

export default function AddFloorModal({ isOpen, onClose, onSave, loading, nextFloorNumber }) {
  const [formData, setFormData] = useState({
    floorNumber: 1,
    floorName: 'Ground Floor'
  });

  useEffect(() => {
    if (isOpen) {
      setFormData({
        floorNumber: nextFloorNumber,
        floorName: nextFloorNumber === 1 ? 'Ground Floor' : `Floor ${nextFloorNumber}`
      });
    }
  }, [isOpen, nextFloorNumber]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      floorNumber: Number(formData.floorNumber),
      floorName: formData.floorName.trim()
    });
  };

  return (
    <div className="fixed inset-0 bg-slate-900/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full" data-testid="add-floor-modal">
        <div className="flex items-center justify-between p-6 border-b border-slate-200">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Building2 className="w-5 h-5 text-primary" />
            </div>
            <h2 className="text-xl font-bold text-slate-900 font-heading">Add Floor</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
            data-testid="close-add-floor-modal"
          >
            <X className="w-5 h-5 text-slate-500" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <Label className="text-sm font-semibold text-slate-700 mb-1.5 block">Floor Number *</Label>
            <Input
              type="number"
              min="1"
              value={formData.floorNumber}
              onChange={(e) => setFormData({ ...formData, floorNumber: Number(e.target.value) })}
              className="h-12 rounded-lg"
              required
              data-testid="add-floor-number"
            />
          </div>

          <div>
            <Label className="text-sm font-semibold text-slate-700 mb-1.5 block">Floor Name *</Label>
            <Input
              value={formData.floorName}
              onChange={(e) => setFormData({ ...formData, floorName: e.target.value })}
              className="h-12 rounded-lg"
              required
              data-testid="add-floor-name"
            />
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              onClick={onClose}
              variant="outline"
              className="flex-1 h-12 rounded-xl"
              disabled={loading}
              data-testid="cancel-add-floor"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="flex-1 h-12 rounded-xl bg-primary"
              disabled={loading}
              data-testid="save-add-floor"
            >
              {loading ? 'Adding...' : 'Add Floor'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
